(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Image-heading"] && !Shopify.designMode) return;
  try {
    
/* Intentionally empty: no JS required for this section */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-text-image"] && !Shopify.designMode) return;
  try {
    
  class InteractiveTextImages {
    constructor(container) {
      this.container = container;
      if (!this.container) return;

      this.triggers = this.container.querySelectorAll('.interactive-trigger');
      this.images = this.container.querySelectorAll('.interactive-image');
      this.init();
    }

    init() {
      if (this.triggers.length === 0) return;

      this.triggers.forEach((trigger) => {
        // A simple way to prevent adding listeners multiple times
        if (trigger.dataset.listenerAttached) return;
        trigger.dataset.listenerAttached = true;

        trigger.addEventListener('click', this.onTriggerClick.bind(this));
      });
    }

    onTriggerClick(event) {
      const clickedTrigger = event.currentTarget;
      const targetId = clickedTrigger.dataset.target;
      if (!targetId) return;

      this.triggers.forEach((t) => t.classList.remove('active'));
      this.images.forEach((i) => i.classList.add('hidden'));

      clickedTrigger.classList.add('active');
      const targetImage = this.container.querySelector(`#${targetId}`);
      if (targetImage) {
        targetImage.classList.remove('hidden');
      }
    }
  }

  function initializeSections() {
    document.querySelectorAll('[data-interactive-section]').forEach((sectionElement) => {
      new InteractiveTextImages(sectionElement);
    });
  }

  // Handle initial page load
  document.addEventListener('DOMContentLoaded', initializeSections);

  // Handle Shopify Theme Editor updates
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const loadedSection = event.target.querySelector('[data-interactive-section]');
      if (loadedSection) {
        new InteractiveTextImages(loadedSection);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
